import { InvoiceSettings, LineItemsOption, PaymentsOption, TotalsOption } from '@wix/ambassador-wix-quotes-web/types';

export type SimpleInvoiceSettings = {
  enabled: boolean;
  showTaxPerLineItem: boolean;
  showTaxBreakdown: boolean;
  showItemsSubtotalPerTax: boolean;
  showTransactionDetails: boolean;
}

export const historicInvoiceSettings: SimpleInvoiceSettings = {
  enabled: false,
  showTaxPerLineItem: false,
  showTaxBreakdown: true,
  showItemsSubtotalPerTax: false,
  showTransactionDetails: false
}

export function simplifySettings(invoiceSettings?: InvoiceSettings): SimpleInvoiceSettings {
  const invoiceSettingsEnabled =
    invoiceSettings?.totalsSettings?.totalsOptions?.includes(
      TotalsOption.NET_TOTALS_INSTEAD_OF_SUBTOTALS,
    ) ?? false;
  if (!invoiceSettingsEnabled) {
    return historicInvoiceSettings
  }
  const showTaxPerLineItem = invoiceSettings?.lineItemsSettings?.lineItemsOptions?.includes(LineItemsOption.SHOW_TAX) ?? false;
  const showTaxBreakdown = invoiceSettings?.totalsSettings?.totalsOptions?.includes(TotalsOption.BREAKDOWN_SUBTOTALS_PER_TAX) ?? false;
  const showItemsSubtotalPerTax = invoiceSettings?.totalsSettings?.totalsOptions?.includes(TotalsOption.ITEMS_SUBTOTAL_PER_TAX_GROUP) ?? false;
  const showTransactionDetails = invoiceSettings?.paymentsSettings?.paymentsOptions?.includes(PaymentsOption.SHOW_TRANSACTION_DETAILS) ?? false;
  const simpleInvoiceSettings: SimpleInvoiceSettings = {
    enabled: invoiceSettingsEnabled,
    showTaxPerLineItem,
    showTaxBreakdown,
    showItemsSubtotalPerTax,
    showTransactionDetails
  }
  return simpleInvoiceSettings;
}
